export default "__VITE_ASSET__XOw7asAS__"